<template>
  <div class="w-full flex flex-col">
    <!-- Status Icon & Label -->
    <div class="flex items-center gap-7 p-2">
      <div class="relative w-5 h-5" :class="{'anim-complete': isComplete}">
        <FormCheckmarkAnimatedIcon :isCompleted="isComplete" />
      </div>
      <BaseText type="label" size="sm" class="text-text-muted">
        {{ label }}
      </BaseText>
    </div>
    <!-- Content -->
    <div class="content-grid">
      <div class="w-full h-full flex justify-center">
        <div v-if="!hideBorder" class="section-border" :class="{'complete': isComplete}" />
      </div>
      <div class="w-full px-5 pt-5 pb-12">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import FormCheckmarkAnimatedIcon from '../../../globals/Icons/FormCheckmarkAnimatedIcon.vue'

export default {
  name: 'CreationStep',
  components: {
    FormCheckmarkAnimatedIcon
  },
  props: {
    label: {
      type: String,
      required: true
    },
    isComplete: {
      type: Boolean,
      default: false
    },
    hideBorder: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.content-grid {
  display: grid;
  grid-template-columns: 36px 1fr;
}
.anim-complete {
  animation: complete 1.5s ease-in-out;
  transform-origin: center center;
}
@keyframes complete {
  0% { transform: scale(1); }
  15% { transform: scale(1.3); }
  80% { transform: scale(1.3); }
  100% { transform: scale(1); }
}
.section-border {
  width: 0px;
  height: 100%;
  border-left: 1px solid;
  border-color: #ECEFF3;
  transition: border-color 1s ease-in-out;
}
.section-border.complete {
  border-color: #B5ECD6;
}
</style>